// frontend/src/services/mlModels.service.ts

import api from './api';

export class MlModelsService {

  /**
   * Lista os modelos disponíveis em produção.
   */
  static async listModels(): Promise<{
    alias: string;
    path: string;
    dataset_name: string;
    pipeline_version: string;
    experiment_id: string;
    model_name: string;
  }[]> {
    const response = await api.get('/ml-models/models');
    return response.data.models ?? [];
  }

  /**
   * Busca o schema (feature_schema + metadata) de um modelo em produção.
   */
  static async getModelSchema(alias: string): Promise<{
    alias: string;
    path: string;
    dataset_name: string;
    pipeline_version: string;
    experiment_id: string;
    model_name: string;
    feature_schema: { features: string[] };
    target_name: string;
    problem_type: string;
    model_metadata: Record<string, any>;
  }> {
    const response = await api.get(`/ml-models/models/${alias}/schema`);
    return response.data;
  }

  /**
   * Executa uma predição com o modelo informado.
   */
  static async predict(payload: {
    model_path: string;
    data: Record<string, number>[];
  }): Promise<{
    model_metadata: Record<string, any>;
    predictions: number[];
  }> {
    const response = await api.post('/ml-models/predict', payload);
    return response.data;
  }
}